import {
  FacebookButton,
  FacebookMessengerButton,
  InstagramButton,
  LinkButton,
  WhatsappButton,
} from 'betterplace-react-components'
import classNames from 'classnames'
import React, { useState } from 'react'
import { CopiedFeedback, facebookAppId, isMobile, t, utmParams } from 'shared'
import './share_icon_group_styles.sass'

type ShareIconGroupProps = {
  shareUrl: string
  utmMedium: string
  className?: string
}

export const ShareIconGroup = ({ shareUrl, utmMedium, className }: ShareIconGroupProps) => {
  const [copyMode, setCopyMode] = useState(false)
  const [copyModeInstagram, setCopyModeInstagram] = useState(false)

  return (
    <>
      <CopiedFeedback copyMode={copyMode} copyModeInstagram={copyModeInstagram} />

      <div className={classNames('share-icon-container', 'mt-medium', 'mb-mini', 'd-flex', className)}>
        <FacebookButton
          boxShadow
          shape="round"
          shareUrl={shareUrl}
          utmParams={utmParams('user_share', utmMedium, 'facebook')}
        />
        {isMobile() && (
          <FacebookMessengerButton
            boxShadow
            shape="round"
            shareUrl={shareUrl}
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            facebookAppId={facebookAppId()!}
            utmParams={utmParams('user_share', utmMedium, 'facebook_messenger')}
          />
        )}
        <WhatsappButton
          boxShadow
          shape="round"
          shareUrl={shareUrl}
          teaser={t('share.whatsapp_body')}
          utmParams={utmParams('user_share', utmMedium, 'whatsapp')}
        />
        {isMobile() && (
          <InstagramButton
            boxShadow
            shape="round"
            shareUrl={shareUrl}
            color={copyModeInstagram ? '#2C662D' : ''}
            beforeOnClick={() => {
              setCopyModeInstagram(true)
              setTimeout(() => {
                setCopyModeInstagram(false)
              }, 3500)
            }}
          />
        )}
        <LinkButton
          boxShadow
          shape="round"
          shareUrl={shareUrl}
          color={copyMode ? '#2C662D' : ''}
          beforeOnClick={() => {
            setCopyMode(true)
            setTimeout(() => {
              setCopyMode(false)
            }, 2000)
          }}
        />
      </div>
    </>
  )
}
